// SocketButtonComponents.js

import { useState, useContext, useEffect } from 'react';
import { Button, Box, Tooltip, makeStyles } from '@material-ui/core';
import DiagramContext from "./Store/DiagramContext";
import CloudOffIcon from '@mui/icons-material/CloudOff';
import TrackChangesIcon from '@mui/icons-material/TrackChanges';

// ✅ NEW: usar helper (ajustá el path según tu proyecto)
import {
    connectWebSocket,
    disconnectWebSocket,
    timeoutRef,
} from '../../helpers/socketFunctions';

const useStyles = makeStyles(theme => ({
    spinning: {
        animation: `$spin 2s infinite`,
    },
    '@keyframes spin': {
        '0%': { transform: 'rotate(0deg)' },
        '50%': { transform: 'rotate(180deg)' },
        '100%': { transform: 'rotate(360deg)' },
    },
}));

const SocketButtonComponent = ({
    macStateAutomate,
    valueDeviceSelected,
    setEdges,
    disabledButtonRealTime,
    stateNavIcon
}) => {
    const classes = useStyles();
    const { setStateDiagram } = useContext(DiagramContext);

    const [stateRealTimeButton, setStateRealTimeButton] = useState(false);
    const [realTimeButtonDisabled, setRealTimeButtonDisabled] = useState(true);

    const path = window.location.pathname;
    const basePath = path?.split('/')?.slice(0, 2)?.join('/');

    // Habilita o deshabilita el botón según la ruta
    useEffect(() => {
        if (basePath === '/plc') {
            if (stateNavIcon?.key === "SYNCHRONIZED") {
                setRealTimeButtonDisabled(false);
            }
        } else {
            setRealTimeButtonDisabled(disabledButtonRealTime);
        }
    }, [disabledButtonRealTime, stateNavIcon, basePath]);

    const startAnimation = () => {
        setEdges(prevEdges =>
            prevEdges.map(edge => ({ ...edge, animated: true }))
        );
    };

    const stopAnimation = () => {
        setEdges(prevEdges =>
            prevEdges.map(edge => ({ ...edge, animated: false }))
        );
        setStateRealTimeButton(false);
    };

    // ✅ NEW: desconexión centralizada (corta timeout + helper disconnect)
    const handleDisconnectRealtime = () => {
        stopAnimation();

        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
            timeoutRef.current = null;
            console.log('clean SetTimeout');
        }

        disconnectWebSocket();
        setStateDiagram(prev => ({
            ...prev,
            socketDiagramState: undefined,
        }));
    };

    // ✅ NEW: conexión usando helper
    const handleConnectRealtime = async () => {
        const timeAux = 30;
        //ejemplo auto24v4m
        const keyProductFormatted =
            valueDeviceSelected?.producto
                ?.split("Automate-")?.[1]
                ?.toLowerCase()
                ?.replace(/-/g, '');
        const finalKey = `auto${keyProductFormatted}`;
        const payload = {
            value: {
                mac: macStateAutomate,
                time: timeAux,
                device_type: finalKey,
                action: "activate_realtime_blocks",
            },
            type: "REALTIME_BLOCKS",
        };

        // stateHelper: recibe los mensajes parseados del helper
        const stateHelper = (msg) => {
            // El helper en onclose manda {status:'disconnected', result:'error'}
            if (msg?.status === 'disconnected') {
                handleDisconnectRealtime();
                return;
            }
            // Mensajes reales
            if (msg) {
                startAnimation();
                setStateDiagram(prev => ({
                    ...prev,
                    socketDiagramState: msg,
                }));
            }
        };
        await connectWebSocket(payload, stateHelper);
        // timeout local usando el timeoutRef global del helper
        timeoutRef.current = setTimeout(() => {
            console.log("Timeout alcanzado, desconectando WebSocket.");
            handleDisconnectRealtime();
        }, timeAux * 1000);
    };

    // Limpieza al desmontar el componente
    useEffect(() => {
        return () => {
            console.log('desmontando SocketButtonComponent');
            handleDisconnectRealtime();
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const realTimeFunction = () => {
        setStateRealTimeButton(true);
        if (stateRealTimeButton) {
            handleDisconnectRealtime();
            return;
        }
        handleConnectRealtime();
    };

    return (
        <Box ml={1}>
            <Tooltip title={'Activar realtime.'} arrow placement="right">
                <span>
                    <Button
                        disabled={realTimeButtonDisabled}
                        variant="contained"
                        size="small"
                        onClick={realTimeFunction}
                    >
                        {stateRealTimeButton ? (
                            <TrackChangesIcon className={classes.spinning} />
                        ) : (
                            <CloudOffIcon />
                        )}
                    </Button>
                </span>
            </Tooltip>
        </Box>
    );
};

export default SocketButtonComponent;
